import React from 'react';

const AdultFooter = () => (
  <svg
    width="216"
    height="216"
    viewBox="0 0 216 216"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="108"
      cy="108"
      r="43"
      fill="#FF016C"
      fillOpacity=".2"
      filter="url(#filterAuditFooter)"
    />
    <path
      d="M90.478 102.04h3.06v19.224h3.96v-25.2h-2.664c-.612 1.692-1.296 3.168-4.356 3.168v2.808zm23.705 13.176v-1.98c0-2.412-.72-4.284-2.448-5.256 1.62-.9 2.448-2.592 2.448-5.076v-.792c0-4.032-2.196-6.336-6.192-6.336s-6.192 2.304-6.192 6.336v.792c0 2.484.792 4.176 2.448 5.076-1.728.972-2.448 2.844-2.448 5.256v1.98c0 4.032 2.196 6.336 6.192 6.336s6.192-2.304 6.192-6.336zm-8.424-.108v-2.34c0-1.98.828-2.844 2.232-2.844 1.404 0 2.232.864 2.232 2.844v2.34c-.036 2.232-.972 2.844-2.232 2.844-1.26 0-2.232-.612-2.232-2.844zm0-12.852c0-2.268.972-2.88 2.232-2.88 1.26 0 2.232.612 2.232 2.88v1.404c0 2.016-.972 2.664-2.232 2.664-1.296 0-2.232-.648-2.232-2.664v-1.404zm17.91.144h-2.808v4.86h-4.824v2.808h4.824V115h2.808v-4.932h4.824v-2.808h-4.824v-4.86z"
      fill="#EFEFEF"
    />
    <defs>
      <filter
        id="filterAuditFooter"
        x="0"
        y="0"
        width="216"
        height="216"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur stdDeviation="32.5" result="effect1_foregroundBlur" />
      </filter>
    </defs>
  </svg>
);

export default AdultFooter;
